module.exports = __webpack_public_path__ + "static/media/land-badge.0bbb47b7.svg";